import type { Document } from '@contentful/rich-text-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { lowerFirst } from 'lodash';

export function getShortFrequencyQuestionData(original: Document): Document {
  return {
    ...original,
    content: original.content
      .filter((item) => item.nodeType.startsWith('heading-'))
      .map((item) => {
        const questionText = item.content[0].nodeType === 'text' ? item.content[0].value : '';
        return {
          ...item,
          nodeType: BLOCKS.PARAGRAPH,
          content: [
            {
              nodeType: 'text',
              value: `Hey Fixter, ${lowerFirst(questionText)}`,
              marks: [],
              data: {},
            },
          ],
        };
      }),
  };
}
